import React from 'react';
import SideNav from '../SideNav';
import NotBo from './NotBo';
import Bo from './Bo';

function TeachingDirector() {
    const { curRole } = sessionStorage;
    const isBO = curRole === 'BO';

    return (
        <div className="content">
            <SideNav selectKey="director" />
            { isBO ? <Bo /> : <NotBo /> }
        </div>
    );
}

export default TeachingDirector;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/director/index.js